import React from 'react';
import LoadingState from '../../ReusableComponents/LoadingState';
import StatusBadge from '../../ReusableComponents/StatusBadge';
export function ErrorNotice({ error }) {
  return error ? (
    <div className="alert alert-danger hidethis" role="alert">
      {error.message}
      {error.fields && Object.keys(error.fields).length > 0 && (
        <ul className="mb-0">
          {Object.entries(error.fields).map(([key, values]) => (
            <li key={key}>{[].concat(values).join(' ')}</li>
          ))}
        </ul>
      )}
    </div>
  ) : null;
}
export function Success({ show, children = 'Alteração salva.' }) {
  return show ? (
    <div className="alert alert-success hidethis" role="status">
      {children}
    </div>
  ) : null;
}
export function Loading() {
  return <LoadingState />;
}
export function Empty({ children }) {
  return <div className="portal-admin-empty">{children}</div>;
}
const names = {
  active: 'Ativa', requested: 'Aguardando envio', submitted: 'Aguardando análise',
  enabled: 'Habilitada',
  disabled: 'Desabilitada',
  queued: 'Na fila',
  partial: 'Concluído com falhas',
  missing: 'Não enviados',
  draft: 'Rascunho',
  published: 'Publicado',
  archived: 'Arquivado',
  under_review: 'Em análise',
  documents_pending: 'Documentos pendentes',
  approved: 'Deferida',
  rejected: 'Indeferida',
  cancelled: 'Cancelada',
  pending: 'Pendente',
  processing: 'Processando',
  synced: 'Vinculado',
  failed: 'Erro',
  not_requested: 'Não solicitado',
  complete: 'Concluído',
  answered: 'Respondido',
};
const variants = {
  active: 'success', requested: 'warning', submitted: 'info',
  enabled: 'success',
  disabled: 'secondary',
  approved: 'success',
  published: 'success',
  synced: 'success',
  complete: 'success',
  answered: 'success',
  rejected: 'danger',
  failed: 'danger',
  cancelled: 'danger',
  queued: 'warning',
  partial: 'warning',
  missing: 'warning',
  pending: 'warning',
  processing: 'warning',
  under_review: 'warning',
  documents_pending: 'warning',
};
export function Status({ value }) {
  return (
    <StatusBadge variant={variants[value] || 'secondary'}>
      {names[value] || value || 'Não informado'}
    </StatusBadge>
  );
}
